import { FC } from 'react';

import { useStatusToast } from '~/components/unified/hooks';
import { AccountUpdateDetailsInput } from '~/generated/graphql';

import { useAccountSettings } from '../api/useAccountSettings';
import { FormTeamProfile } from './FormTeamProfile';

export const CompanyTeamSettings: FC = () => {
  const {
    loading,
    name,
    mfaEnforced,
    updateAccountDetails,
  } = useAccountSettings();

  const { addSuccessToast, addErrorToast } = useStatusToast();

  const handleUpdate = async (value: AccountUpdateDetailsInput) => {
    const res = await updateAccountDetails({
      variables: {
        input: value,
      },
    });

    if (res.data?.updateAccountDetails?.errors?.length) {
      addErrorToast({
        description: 'We were unable to update your team, please try again.',
        heading: 'Team update failed',
      });
    } else {
      addSuccessToast({
        description: 'Team settings have been updated.',
        heading: 'Team updated',
      });
    }
  };

  if (loading) return null;

  return (
    <FormTeamProfile onChange={handleUpdate} value={{ name, mfaEnforced }} />
  );
};
